export default __webpack_public_path__ + "static/media/self_portrait_red_light.6f05d711.jpg";